import { useMutation } from '@tanstack/react-query';
import axios from 'axios';

import { type Credentials } from '@/types/auth';
import { type Session } from '@/types/session';

async function validateSignUp(credentials: Credentials) {
  const { data } = await axios.post<{ session: Session }>(
    `/v1/dashboard/accounts/validate-sign-up`,
    {
      ...credentials
    },
    { withCredentials: true }
  );

  return data.session;
}

export function useValidateSignUpMutation() {
  return useMutation({
    mutationFn: validateSignUp
  });
}
